import makeRequest from 'utils/makeRequest';
import {
  getFeedUrl,
  getInternalFeedUrl,
  getTopicFeedUrl,
} from 'helpers/feeds/generalHelpers';

import { receiveNavigationData } from './header';
import { receiveFooterData } from './footer';
import { receiveCommonData } from './common';
import { receiveSidebarData } from './sidebar';
import { receiveCommonWidgetsData } from './widgets';
import { receiveSchemaData } from './schema';
import { receiveSeoData } from './seo';

//const HP_LAYOUT_API_PATH = '/toi/web/page/layout?vesrion=v2&path=/';
const DEFAULT_LAYOUT_API_PATH = '/toi/web/show/news?layout=1&version=v2&path=';
const PHOTOSTORY_LAYOUT_API_PATH =
  '/toi/web/show/photostory?layout=1&version=v2&path=';
const MOVIE_REVIEW_LAYOUT_API_PATH =
  '/toi/web/show/moviereview?layout=1&version=v2&path=/movie-review/';
const DEFAULT_COMMON_API_PATH = '/toi/web/page/common?version=v2&path=';
const DEFAULT_SIDEBAR_API_PATH = '/toi/web/page/sidebar?version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_LB = '/toi/web/show/lb?layout=1&version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_VIDEO =
  '/toi/web/show/video?layout=1&version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_LIST =
  '/toi/web/list/news?layout=1&version=v2&path=';
// const DEFAULT_LAYOUT_API_PATH_COVID =
//   '/toi/web/list/news?layout=1&version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_TOPIC =
  '/toi/web/show/topic?layout=1&version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_TOIP = '/toi/web/list/section?layout=1&path=';
const DEFAULT_LAYOUT_API_PATH_VISUALSTORIES =
  '/toi/web/list/newsV2?layout=1&version=v2&path=';
const DEFAULT_LAYOUT_API_PATH_CARTOON =
  '/toi/web/show/cartoon?layout=1&version=v2&path=';

function getActiveSectionPath(path) {
  let activeSectionPath = '/';
  if (path.indexOf('.cms') !== -1) {
    // #todo to be done using regex
    const pathParts = path.split('/');
    const pathSections = pathParts.slice(0, pathParts.length - 3);

    if (pathSections && pathSections.length >= 2) {
      activeSectionPath = pathSections.join('/');
    }
  } else {
    // short URL / listing pages
    activeSectionPath = path || activeSectionPath;
  }
  return activeSectionPath;
}

function callLayoutApi(params, isWapView) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const reviewsPageParam = params.isReviewsPage
    ? '&isreviewspage=yes&isreviewsnewdomain=yes'
    : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH}${
    params.fullPath
  }${primeParam}${isClientConsumable}${reviewsPageParam}`;
  return makeRequest.get(feedUrl, { isMobile: isWapView });
}

function callPhotostoryLayoutApi(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const feedUrl = `${getFeedUrl()}${PHOTOSTORY_LAYOUT_API_PATH}${
    params.fullPath
  }${primeParam}${isClientConsumable}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callMovieReviewLayoutApi(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const feedUrl = `${getFeedUrl()}${MOVIE_REVIEW_LAYOUT_API_PATH}${
    params.msid
  }.cms${primeParam}${isClientConsumable}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiVideo(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_VIDEO}${
    params.fullPath
  }${primeParam}${isClientConsumable}`;
  // console.log(feedUrl);
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiCartoon(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const isClientConsumable = params.isClientConsumable
    ? '&test=consumable'
    : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_CARTOON}${
    params.fullPath
  }${primeParam}${isClientConsumable}`;
  // console.log(feedUrl);
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiLB(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_LB}${
    params.shortPath
  }${primeParam}`;
  // console.log(feedUrl);
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiList(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const reviewsPageParam = params.isReviewsPage
    ? '&isreviewspage=yes&isreviewsnewdomain=yes'
    : '';
  const bclabelParam = params.bclabel ? `&bclabel=${params.bclabel}` : '';
  const bclinkParam = params.bclink ? `&bclink=${params.bclink}` : '';
  const rndfeedTest =
    params.fullPath === '/' && params.rndfeed && params.rndfeed === '1'
      ? '&test=rndfeed'
      : '';

  let feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_LIST}${
    params.fullPath
  }${primeParam}${rndfeedTest}${reviewsPageParam}${bclabelParam}${bclinkParam}`;
  if (params.useInternalFeed) {
    feedUrl = `${getInternalFeedUrl()}${DEFAULT_LAYOUT_API_PATH_LIST}${
      params.fullPath
    }${primeParam}${rndfeedTest}`;
  }
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

// function callLayoutApiCovid(params) {
//   const primeParam = params.isPrime ? '&pc=yes' : '';
//   const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_COVID}${
//     params.fullPath
//   }${primeParam}`;
//   // console.log(feedUrl);
//   return makeRequest.get(feedUrl);
// }

function callCommonApi(params, resolvedRoute = '/') {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const activeSectionPath = getActiveSectionPath(params.fullPath);
  const feedUrl = `${getFeedUrl()}${DEFAULT_COMMON_API_PATH}${activeSectionPath}&template=${resolvedRoute}${primeParam}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callSidebarApi(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  let xtraParam = '';
  if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/sports/')
  ) {
    xtraParam = '&template=sportsLb';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/entertainment/')
  ) {
    xtraParam = '&template=etimesmovies';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/tv/')
  ) {
    xtraParam = '&template=etimestv';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/life-style/')
  ) {
    xtraParam = '&template=etimeslifestyle';
  }

  const feedUrl = `${getFeedUrl()}${DEFAULT_SIDEBAR_API_PATH}${
    params.fullPath
  }${primeParam}${xtraParam}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callSidebarApiMobile(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  let xtraParam = '';
  if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/sports/')
  ) {
    xtraParam = '&template=sportsLb';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/entertainment/')
  ) {
    xtraParam = '&template=etimesmovies';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/tv/')
  ) {
    xtraParam = '&template=etimestv';
  } else if (
    params.fullPath.includes('/liveblog/') &&
    params.fullPath.includes('/life-style/')
  ) {
    xtraParam = '&template=etimeslifestyle';
  }
  const feedUrl = `${getFeedUrl()}${DEFAULT_SIDEBAR_API_PATH}${
    params.fullPath
  }${primeParam}${xtraParam}`;
  return makeRequest.getwap(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiTopic(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const feedUrl = `${getTopicFeedUrl()}${DEFAULT_LAYOUT_API_PATH_TOPIC}${
    params.fullPath
  }${primeParam}`;
  // console.log(feedUrl);
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}
function callVisualStoriesLayoutApiList(params) {
  const primeParam = params.isPrime ? '&pc=yes' : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_VISUALSTORIES}${
    params.fullPath
  }${primeParam}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

function callLayoutApiTOIP(params) {
  const searchKeyword = params?.searchKeyword ? params.searchKeyword : '';
  const feedUrl = `${getFeedUrl()}${DEFAULT_LAYOUT_API_PATH_TOIP}/toi-plus/${searchKeyword}`;
  return makeRequest.get(feedUrl, { isMobile: params.isWapView });
}

export function loadSidebarData(params) {
  return dispatch =>
    callSidebarApi(params).then(response => {
      const { data = {} } = response;
      dispatch(receiveSidebarData(data));
    });
}

export function loadSidebarDataMobile(params) {
  return dispatch =>
    callSidebarApiMobile(params).then(response => {
      const { data = {} } = response;
      dispatch(receiveSidebarData(data));
    });
}

export function loadCommonData(params, resolvedRoute) {
  return dispatch =>
    callCommonApi(params, resolvedRoute).then(response => {
      const { data = {} } = response;
      dispatch(receiveCommonData(data));
    });
}

// eslint-disable-next-line import/prefer-default-export
export function loadLayoutData(params) {
  return (dispatch, getState) => {
    const appState = getState();
    const { isMobile } = appState;
    return callLayoutApi(params, isMobile)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        dispatch(receiveNavigationData({}));
        dispatch(receiveFooterData({}));
        dispatch(receiveCommonData({}));
        // console.log('somthing went wrong with layout call');
      });
  };
}

export function loadPhotostoryLayoutData(params) {
  return (dispatch, getState) => {
    const appState = getState();
    const { isMobile } = appState;
    return callPhotostoryLayoutApi(params, isMobile)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.seo) {
          dispatch(receiveSeoData(data.seo));
        }
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
        if (data.widgets) {
          dispatch(receiveCommonWidgetsData(data.widgets));
        }
      })
      .catch(() => {
        dispatch(receiveNavigationData({}));
        dispatch(receiveFooterData({}));
        dispatch(receiveCommonData({}));
      });
  };
}

export function loadMovieReviewLayoutData(params) {
  return (dispatch, getState) => {
    const appState = getState();
    const { isMobile } = appState;
    return callMovieReviewLayoutApi(params, isMobile)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.seo) {
          dispatch(receiveSeoData(data.seo));
        }
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
        if (data.widgets) {
          dispatch(receiveCommonWidgetsData(data.widgets));
        }
      })
      .catch(() => {
        dispatch(receiveNavigationData({}));
        dispatch(receiveFooterData({}));
        dispatch(receiveCommonData({}));
      });
  };
}

export function loadLayoutDataVideo(params) {
  return dispatch =>
    callLayoutApiVideo(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        dispatch(receiveNavigationData({}));
        dispatch(receiveFooterData({}));
        dispatch(receiveCommonData({}));
        // console.log('somthing went wrong with layout call');
      });
}

export function loadLayoutDataCartoon(params) {
  return dispatch =>
    callLayoutApiCartoon(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
        if (data.seo) {
          dispatch(receiveSeoData(data.seo));
        }
        if (data.schema) {
          dispatch(receiveSchemaData(data.schema));
        }
      })
      .catch(() => {
        dispatch(receiveNavigationData({}));
        dispatch(receiveFooterData({}));
        dispatch(receiveCommonData({}));
        // console.log('somthing went wrong with layout call');
      });
}

export function loadLayoutDataList(params) {
  return dispatch =>
    callLayoutApiList(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
        if (data.seo) {
          dispatch(receiveSeoData(data.seo));
        }
        if (data.schema) {
          dispatch(receiveSchemaData(data.schema));
        }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataList call');
      });
}
export function loadVisualStoriesLayoutDataList(params) {
  return dispatch =>
    callVisualStoriesLayoutApiList(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataList call');
      });
}
export function loadVocListingLayoutDataList(params) {
  return dispatch =>
    callLayoutApiList(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataList call');
      });
}

export function loadLayoutDataLB(params) {
  return dispatch =>
    callLayoutApiLB(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        // if (data.sidebar) {
        //   dispatch(receiveSidebarData(data.sidebar));
        // }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataLB call');
      });
}

export function loadLayoutDataUSHP(params) {
  return dispatch =>
    callLayoutApiList(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataUSHP call');
      });
}

export function loadLayoutDataTopic(params) {
  return dispatch =>
    callLayoutApiTopic(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
        dispatch(receiveCommonData(data.common));
        if (data.sidebar) {
          dispatch(receiveSidebarData(data.sidebar));
        }
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataTopic call');
      });
}

export function loadLayoutDataTOIP(params) {
  return dispatch =>
    callLayoutApiTOIP(params)
      .then(response => {
        const { data = {} } = response;
        dispatch(receiveNavigationData(data.header));
        dispatch(receiveFooterData(data.footer));
      })
      .catch(() => {
        // console.log('somthing went wrong with loadLayoutDataTOIP call');
      });
}
